// extracted by mini-css-extract-plugin
var _1 = "badge_badge__9spx+";
var _2 = "badge_badgecontent__goqae";
var _3 = "badge_hastooltip__ane6h";
var _4 = "badge_tooltipicon__ti9ud";
export { _1 as "badge", _2 as "badgeContent", _3 as "hasTooltip", _4 as "tooltipIcon" }
